import Component from './legal-representative-form';
export default Component;
